import { ReduxBaseAction } from '../../domain/redux/ReduxBaseAction';
import { MLOpsModel } from '../../domain/mlops/MLOpsDomains';

export type AiModelActions =
  | 'CHANGE_AI_MODEL'
  | 'CHANGE_AI_MODEL_IS_UPDATE'
  | 'CLEAR_AI_MODEL'
  | 'CHANGE_AI_MODEL_TRAINING_FILE'
  | 'CHANGE_AI_MODEL_VALIDATION_FILE';

export const changeAiModel = (payload: MLOpsModel | null) =>
  ({
    type: 'CHANGE_AI_MODEL',
    payload,
  }) as ReduxBaseAction<MLOpsModel, AiModelActions>;

export const changeAiModelIsUpdate = (payload: boolean) =>
  ({
    type: 'CHANGE_AI_MODEL_IS_UPDATE',
    payload,
  }) as ReduxBaseAction<boolean, AiModelActions>;

export const clearAiModel = () =>
  ({
    type: 'CLEAR_AI_MODEL',
    payload: void 0,
  }) as ReduxBaseAction<void, AiModelActions>;

export const changeAiModelTrainingFile = (payload: File | null) =>
  ({
    type: 'CHANGE_AI_MODEL_TRAINING_FILE',
    payload,
  }) as ReduxBaseAction<File | null, AiModelActions>;

export const changeAiModelValidationFile = (payload: File | null) =>
  ({
    type: 'CHANGE_AI_MODEL_VALIDATION_FILE',
    payload,
  }) as ReduxBaseAction<File | null, AiModelActions>;
